import Loader from 'react-loaders'
import Main from "../../src/Pages/index"
import { useSelector } from 'react-redux'


const LoadingOverlayWrapper = ({ children }) => {
  const loader = useSelector((state) => state.Loader.loader)
  return (
    <div style={{ position: 'relative' }}>
      {loader && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 99999999,
            background: 'rgba(255,255,255,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <Loader active color='#000' type='ball-pulse' />
        </div>
      )}
      <Main>{children}</Main>
    </div>
  )
}

export default LoadingOverlayWrapper
